define(
    ['jquery', 'underscore', 'assets/js/common/router/index', 'jquery-ui/jquery-ui', 'selectboxit/src/javascripts/jquery.selectBoxIt.min'],
    function($, _, router) {
        var FileSpecs = function(allProducts) {
            var self = this;

            this.DEFAULT_FOLDING_VALUE = 'No folding';
            this.allProducts = allProducts;
            this.$fileFormats = $('#file-formats').find('[data-program]');
            this.$useStartFileDiv = $('#how-to-use-start-file');
            this.$createStartFileDiv = $('#how-to-create-start-file');
            this.$startFileLink = $('#start-file-link');
            this.$productSelect = $('#all-products');
            this.$foldings = $('#foldings');
            this.$loadingImg = $('<img/>').attr({
                src: '/img1/loading.gif',
                alt: 'loading bar',
                width: 220,
                height: 19
            });
            this.$loadingDialog = $('<div/>')
                .addClass('preload')
                .append(this.$loadingImg)
                .appendTo('body');
            this.program = '';
            this.programs = {};
            this.product = '';
            this.foldings = [];
            this.folding = '';

            this.$fileFormats.click(function(e) {
                e.preventDefault();
                self.onProgramClick($(this));
            });

            this.$productSelect.on('change', function() {
                self.onProductChange();
            });

            this.$foldings.on('change', function() {
                self.onFoldingChange();
            });

            this.$loadingDialog.dialog({
                draggable: false,
                width: 220,
                height: 19,
                minHeight: 19,
                minWidth: 220,
                modal: true,
                resizable: false,
                dialogClass: 'transparent noTitleStuff loading-popup',
                autoOpen: false
            });

            this.init();
        };

        FileSpecs.prototype = {
            init: function() {
                this.$productSelect.trigger('change');
                this.$productSelect.selectBoxIt();
            },

            onProductChange: function() {
                var self = this;
                this.product = this.$productSelect.val();
                $.ajax({
                    url: router.generate('/api/products/{slug}', { slug: self.product }),
                    success: function(data) {
                        self.programs = {};
                        self.foldings = {};
                        if (data && data.start_files) {
                            var hasFilter = false;
                            data.start_files.filter(function(file) {
                                if (file.filter) {
                                    hasFilter = true;
                                }
                            });
                            data.start_files.filter(function(file) {
                                if (hasFilter) {
                                    if (!self.programs[file.type]) {
                                        self.programs[file.type] = {};
                                    }
                                    if (!self.programs[file.type]['folding']) {
                                        self.programs[file.type]['folding'] = {};
                                    }
                                    self.programs[file.type]['folding'][file.filter] = file.url;

                                    data.options.filter(function(option) {
                                        if (option.name === 'folding') {
                                            option.option_values.filter(function(optionValue) {
                                                if (optionValue.name === file.option) {
                                                    self.foldings[file.filter] = optionValue.title;
                                                }
                                            });
                                        }
                                    });
                                } else {
                                    self.programs[file.type] = file.url;
                                }
                            });

                            self.updateFoldingSelect();
                            self.updateInfo();
                        }
                    }
                });
            },

            onProgramClick: function($program) {
                var self = this;
                this.setProgram($program.data('program'));

                this.removeSelected();
                $program.addClass('selected');

                this.updateTitle();
                this.updateUseStartFileInfo();

                if ($program.is('[data-file-actions*=create]')) {
                    this.$loadingDialog.dialog('open');
                    $.ajax({
                        url: $program.attr('href'),
                        success: function(data) {
                            self.$createStartFileDiv.find('.content').html(data);
                            self.updateCreateStartFileInfo();
                        },
                        complete: function() {
                            self.$loadingDialog.dialog('close');
                        }
                    });
                } else {
                    this.$createStartFileDiv.hide();
                }
            },

            onFoldingChange: function() {
                this.folding = this.$foldings.val();
                if (this.folding === '') {
                    this.folding = this.DEFAULT_FOLDING_VALUE;
                }
                this.updateUseStartFileInfo();
            },

            updateInfo: function() {
                this.updatePrograms();
                this.updateTitle();
                this.setProgram();
                if (this.program) {
                    this.$fileFormats.filter('[data-program=' + this.program + ']').trigger('click');
                } else {
                    this.$createStartFileDiv.hide();
                    this.$useStartFileDiv.hide();
                }
            },

            removeSelected: function() {
                this.$fileFormats.removeClass('selected');
            },

            updatePrograms: function() {
                var self = this;
                this.$fileFormats.filter('[data-file-actions=use]').each(function() {
                    var program = $(this).data('program');
                    if (self.programs[program] == undefined) {
                        $(this).hide();
                    } else {
                        $(this).show();
                    }
                });
            },

            setProgram: function(program) {
                if (program) {
                    this.program = program;
                    return;
                }
                if (this.program && this.$fileFormats.filter('[data-program=' + this.program + ']').is(':hidden')) {
                    this.setFirstProgram();
                }
            },

            setFirstProgram: function() {
                this.program = this.$fileFormats
                    .filter(':visible')
                    .first()
                    .data('program');
            },

            updateFoldingSelect: function() {
                var self = this;
                this.$foldings.hide();

                if (!_.isEmpty(this.foldings)) {
                    // there must be different value against No Folding otherwise selectboxit disallow change "Choose Folding Type" to "No Folding"
                    this.$foldings.html('<option value="">Choose Folding Type</option>');
                    _.each(this.foldings, function(foldingTitle, folding) {
                        $('<option></option>')
                            .val(folding)
                            .html(foldingTitle)
                            .appendTo(self.$foldings);
                    });
                    var $option = this.$foldings.find('option').first();
                    if (this.folding) {
                        var $foldingOption = this.$foldings.find('option[value="' + this.folding + '"]');
                        if ($foldingOption.length) {
                            $option = $foldingOption;
                        }
                    }
                    $option.prop('selected', true);
                    this.$foldings.selectBoxIt();
                    this.$foldings.data('selectBox-selectBoxIt').refresh();
                    this.folding = $option.val();
                } else {
                    $('#foldingsSelectBoxItContainer').hide();
                    this.folding = '';
                }
            },

            updateTitle: function() {
                var $title = $('#set-program');
                if (this.program) {
                    var title = this.$fileFormats
                        .filter('[data-program=' + this.program + ']')
                        .children('span')
                        .html();
                    $title.show().html(title);
                    $title.prev('.divider').show();
                } else {
                    $title.hide();
                    $title.prev('.divider').hide();
                }
            },

            updateUseStartFileInfo: function() {
                var link;
                if (this.folding === '') {
                    this.folding = this.DEFAULT_FOLDING_VALUE;
                }

                if (this.program && this.programs[this.program] != undefined) {
                    if (this.folding && this.programs[this.program].folding != undefined) {
                        if (this.programs[this.program].folding[this.folding] != undefined) {
                            link = this.programs[this.program].folding[this.folding];
                        }
                    } else {
                        link = this.programs[this.program];
                    }
                }

                if (link) {
                    this.$startFileLink.attr('href', link);
                    this.$useStartFileDiv.find('.set-dpi').html(this.allProducts[this.product].sizes['resolution']);
                    this.$useStartFileDiv.show();
                    this.$useStartFileDiv.next('.divider').show();
                } else {
                    this.$useStartFileDiv.hide();
                    this.$useStartFileDiv.next('.divider').hide();
                }
            },

            updateCreateStartFileInfo: function() {
                if (this.program) {
                    this.$createStartFileDiv.show();
                    this.setFileSize();
                } else {
                    this.$createStartFileDiv.hide();
                }
            },

            setFileSize: function() {
                var width = this.program === 'word' ? 'fullbleed_width' : 'px_width';
                var height = this.program === 'word' ? 'fullbleed_height' : 'px_height';

                this.$createStartFileDiv.find('#set-width').html(this.allProducts[this.product].sizes[width]);
                this.$createStartFileDiv.find('#set-height').html(this.allProducts[this.product].sizes[height]);
                this.$createStartFileDiv.find('.set-dpi').html(this.allProducts[this.product].sizes['resolution']);
                this.$createStartFileDiv.find('.set-bleed').html(this.allProducts[this.product].sizes['bleedsize']);
                this.$createStartFileDiv.find('.set-product').html(this.allProducts[this.product].productTitle);
            }
        };

        return FileSpecs;
    }
);
